import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FilterSelectIndustries from 'syft-acp-util/components/FilterForm/FilterSelectIndustries'

const DataIndustriesDropdown = ({ value, editable, actions, allowAny, queryKey, options, name }) => {
  return editable ? (
    <FilterSelectIndustries
      name={name}
      value={value}
      allowAny={allowAny}
      actions={actions}
      disabled={!editable}
      queryKey={queryKey}
      options={options}
    />
  ) : (
    <div className="plain-text">{value}</div>
  )
}

DataIndustriesDropdown.propTypes = {
  value: PropTypes.number,
  editable: PropTypes.bool,
  allowAny: PropTypes.bool,
  actions: PropTypes.object.isRequired,
  queryKey: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
}

DataIndustriesDropdown.defaultProps = {
  value: null,
  editable: true,
  allowAny: false,
}

export default connect((state, { onChange }) => ({
  actions: {
    setFilter: (name, id, value) => onChange(value, id, name),
  },
}))(DataIndustriesDropdown)
